import { render, staticRenderFns } from "./viewLog.vue?vue&type=template&id=2bf0e3ae&scoped=true"
import script from "./viewLog.vue?vue&type=script&lang=js"
export * from "./viewLog.vue?vue&type=script&lang=js"
import style0 from "./viewLog.vue?vue&type=style&index=0&id=2bf0e3ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0e3ae",
  null
  
)

export default component.exports